import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchOrganizations, createOrganization, updateOrganization, deleteOrganization } from "../api/administrationService";

export const useOrganizations = () => {
  const queryClient = useQueryClient();

  // Obtener las organizaciones
  const {
    data: organizations = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["organizations"],
    queryFn: fetchOrganizations,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  // Invalidar caché tras una mutación
  const invalidateOrganizationsCache = () => {
    queryClient.invalidateQueries({ queryKey: ["organizations"] });
  };

  // Mutación para crear una organización
  const createMutation = useMutation({
    mutationFn: createOrganization,
    onSuccess: invalidateOrganizationsCache,
  });

  // Mutación para actualizar una organización
  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateOrganization(id, data),
    onSuccess: invalidateOrganizationsCache,
  });

  // Mutación para eliminar una organización
  const deleteMutation = useMutation({
    mutationFn: deleteOrganization,
    onSuccess: invalidateOrganizationsCache,
  });

  return {
    organizations,
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
